import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useTypeTodayReorder } from 'features/user';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SelfSortingTaskCardTaskSection } from 'shared/components/ui/task-card-task-section';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useActiveTaskId } from 'shared/contexts/task-detail';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';
import { TypeSections } from 'shared/types/page-sections';
import { DueDisplayOptions } from 'shared/types/task-base';

import { useFullCalendarDraggableTasks } from '../../hooks/use-full-calendar-draggable-tasks';
import { useTypeTaskSections } from '../../hooks/use-type-task-sections';
import { SectionHeaderToday } from '../section-header-today';
import * as Styled from './type-grouping-tasks-list.style';

const displayDue = [DueDisplayOptions.Past, DueDisplayOptions.Future];

export const TypeGroupingTasksList: React.FC = () => {
  const { t } = useTranslation();
  const today = useToday();
  const user = useUser();
  const { sections, taskCardTasks } = useTypeTaskSections();
  const reorderType = useTypeTodayReorder();
  const containerRef = React.useRef<HTMLDivElement>(null);

  const selectedTask = useActiveTaskId();

  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();

  const openPremiumDialog = useOpenPremiumDialog();

  const tasks = useMemo(
    () => taskCardTasks.map(({ raw }) => raw.task),
    [taskCardTasks],
  );
  useFullCalendarDraggableTasks(tasks, containerRef);

  return (
    <Styled.Container ref={containerRef}>
      {sections.map(({ id, items }) => {
        const onReorder = (ids: ID[]) => reorderType(id, ids);

        return (
          <Styled.Section key={id}>
            <SelfSortingTaskCardTaskSection
              date={today}
              tagIds={user?.settings?.todayFilterByTags}
              goals={goals}
              lifeAreas={lifeAreas}
              tasks={items}
              selectedTask={selectedTask}
              displayDue={displayDue}
              customHeader={
                <SectionHeaderToday
                  title={t(`general.sections.type.${id}.title`)}
                />
              }
              onReorder={onReorder}
              canCreateTask={id !== TypeSections.Habits}
              canCreateHabit={id === TypeSections.Habits}
              onPremium={openPremiumDialog}
              canCollapse
            />
          </Styled.Section>
        );
      })}
    </Styled.Container>
  );
};
